// src/components/Admin/Purchases/PurchaseAttachments.js
import React, { useEffect, useState } from "react";
import { Box, Button, List, ListItem, ListItemText, IconButton, Typography, Stack, Chip } from "@mui/material";
import { Delete, CloudUpload } from "@mui/icons-material";
import { usePurchases } from "../../../hook/usePurchases";


export function PurchaseAttachments({ purchase, onClose }) {
  const { listAttachments, uploadAttachment, deleteAttachment } = usePurchases();
  const [items, setItems] = useState([]);

  const load = async () => {
    if (purchase?.id) {
      const res = await listAttachments(purchase.id);
      setItems(res || []);
    }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [purchase?.id]);

  const onUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    await uploadAttachment({ purchase: purchase.id, file, kind: guessKind(file) });
    await load();
    e.target.value = "";
  };

  const onDelete = async (id) => {
    await deleteAttachment(id);
    await load();
  };

  const guessKind = (file) => {
    const name = file.name.toLowerCase();
    if (name.endsWith(".xml")) return "xml";
    if (name.endsWith(".pdf")) return "invoice_pdf";
    if (name.match(/\.(jpg|jpeg|png|webp)$/)) return "receipt_img";
    return "other";
    }

  return (
    <Box>
      <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
        <Typography variant="subtitle1">Adjuntos de Compra #{purchase?.id}</Typography>
        <Button component="label" startIcon={<CloudUpload />} variant="outlined">
          Subir archivo
          <input hidden type="file" onChange={onUpload} />
        </Button>
      </Stack>

      <List dense>
        {items.map((a) => (
          <ListItem key={a.id}
            secondaryAction={<IconButton edge="end" onClick={() => onDelete(a.id)}><Delete /></IconButton>}>
            <ListItemText
              primary={
                <Stack direction="row" spacing={1} alignItems="center">
                  <span>{a.original_name || a.file?.split("/").pop()}</span>
                  <Chip size="small" label={a.kind} />
                  <Chip size="small" label={`${Math.round((a.size || 0)/1024)} KB`} />
                </Stack>
              }
              secondary={a.created_at}
            />
          </ListItem>
        ))}
        {items.length === 0 && <Typography variant="body2"><em>No hay archivos.</em></Typography>}
      </List>

      <Box mt={2} display="flex" justifyContent="flex-end">
        <Button onClick={onClose}>Cerrar</Button>
      </Box>
    </Box>
  );
}
